import { RootActionTypes } from '../../../stores/types';
import { OrderRefundAmount } from '../types';
import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';

export default function updateRefundAmount(refundObj: OrderRefundAmount): RootActionTypes {
  return standardAction(ActionTypes.UPDATE_REFUND_AMOUNT, refundObj);
}
